<template>
  <div class="rn-notarios-area notarios-area rn-section-gap bg_color--1">
    <v-container>
      <!-- Skeleton Loader Area -->
      <div v-if="store.loading" class="rn-content-box-area rn-content-box-style--1 bg_color--1">
        <v-row class="row--10">
          <v-col 
            :cols="12" 
            :sm="Number(NOTARIA.Theme.Notarios.NumeroColumnas || 1) == 1 ? 12 : 6" 
            :md="comNumColumnas" 
            v-for="n in 3" 
            :key="'notario-skel-' + n"
            class="mb-10"
          >
            <v-card class="elevation-0 border-0 bg-transparent">
              <!-- Skeleton Horizontal -->
              <div v-if="Number(NOTARIA.Theme.Notarios.NumeroColumnas || 1) == 1" class="d-flex flex-column flex-md-row align-center pa-10 bg-white rounded-lg">
                <v-skeleton-loader type="image" width="300" height="300" class="rounded-lg mr-md-10 mb-6 mb-md-0" :color="style.ThemeGeneral?.TextoCss?.Color ? style.ThemeGeneral.TextoCss.Color + '10' : 'rgba(0,0,0,0.05)'"></v-skeleton-loader>
                <div class="flex-grow-1 w-100">
                  <v-skeleton-loader type="heading" class="mb-4" :color="style.ThemeGeneral?.TextoCss?.Color ? style.ThemeGeneral.TextoCss.Color + '10' : 'rgba(0,0,0,0.05)'"></v-skeleton-loader>
                  <v-skeleton-loader type="paragraph" :color="style.ThemeGeneral?.TextoCss?.Color ? style.ThemeGeneral.TextoCss.Color + '10' : 'rgba(0,0,0,0.05)'"></v-skeleton-loader>
                </div>
              </div>
              <!-- Skeleton Vertical -->
              <div v-else class="pa-6 bg-white rounded-lg h-100">
                <v-skeleton-loader type="image" height="250" class="rounded-lg mb-4" :color="style.ThemeGeneral?.TextoCss?.Color ? style.ThemeGeneral.TextoCss.Color + '10' : 'rgba(0,0,0,0.05)'"></v-skeleton-loader>
                <v-skeleton-loader type="heading" class="mb-3" :color="style.ThemeGeneral?.TextoCss?.Color ? style.ThemeGeneral.TextoCss.Color + '10' : 'rgba(0,0,0,0.05)'"></v-skeleton-loader>
                <v-skeleton-loader type="text" :color="style.ThemeGeneral?.TextoCss?.Color ? style.ThemeGeneral.TextoCss.Color + '10' : 'rgba(0,0,0,0.05)'"></v-skeleton-loader>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </div>

      <div class="rn-content-box-area rn-content-box-style--1 bg_color--1" id="notarios" v-if="!store.loading">
        <v-row class="row--10" align="stretch">
          <v-col 
            :cols="12" 
            :sm="NOTARIA.Theme.Notarios.NumeroColumnas == 1 ? 12 : 6" 
            :md="comNumColumnas" 
            v-for="notario in NOTARIA.Notarios" 
            :key="notario.id" 
            class="mb-10"
          >
            <!-- Layout Horizontal (1 columna) -->
            <div v-if="Number(NOTARIA.Theme.Notarios.NumeroColumnas || 1) == 1" class="notario-horizontal-card d-flex flex-column align-center" :class="notario.ImageLeft === false ? 'flex-md-row-reverse' : 'flex-md-row'">
              <div class="notario-image-wrapper d-flex justify-center align-center" v-if="notario.Imagen !== ''">
                <div class="thumbnail horizontal-thumb" :style="{ maxHeight: imageMaxHeight }">
                  <img :src="imagenIDtoSRC(notario.Imagen)" alt="Imagen del Notario" class="hover-zoom"/>
                </div>
              </div>
              <div class="notario-content-wrapper d-flex flex-column justify-center">
                <div class="notarios-card text-left">
                  <h3 :style="tituloStyle" class="mb-4">{{ notario.Nombre }}</h3>
                  <div class="description-container mb-6">
                    <p v-html="notario.Descripcion.replace(/(?:\r\n|\r|\n)/g, '<br>')" :style="descripcionStyle"></p>
                  </div>
                  <div class="notarios-links">
                    <a v-if="notario.Email" :title="$t('contactar') + ': ' + notario.Nombre" :href="'mailto:' + notario.Email" class="link-item">
                      <v-icon :color="estiloTarjetaTituloColor">mdi-email-outline</v-icon>
                      <span :style="{ color: estiloTarjetaTituloColor }" class="ml-2 d-none d-md-inline">{{ $t('contactar') }}</span>
                    </a>
                    <a v-if="notario.Web" :title="$t('webPersonal') + ': ' + notario.Nombre" :href="notario.Web" target="_blank" class="link-item">
                      <v-icon :color="estiloTarjetaTituloColor">mdi-web</v-icon>
                      <span :style="{ color: estiloTarjetaTituloColor }" class="ml-2 d-none d-md-inline">{{ $t('webPersonal') }}</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <!-- Layout Vertical/Card (Multi-columna) -->
            <div v-else class="notarios-card-vertical h-100 d-flex flex-column">
              <div class="thumbnail mb-4" v-if="notario.Imagen !== ''" :style="{ maxHeight: imageMaxHeight }">
                <img :src="imagenIDtoSRC(notario.Imagen)" alt="Imagen del Notario"/>
              </div>
              <div class="inner d-flex flex-column flex-grow-1">
                <h3 :style="tituloStyle" class="mb-3">{{ notario.Nombre }}</h3>
                <p v-html="notario.Descripcion.replace(/(?:\r\n|\r|\n)/g, '<br>')" :style="descripcionStyle" class="flex-grow-1"></p>
                <div class="notarios-links mt-auto">
                  <a v-if="notario.Email" :title="'Enviar email a ' + notario.Nombre" :href="'mailto:' + notario.Email">
                    <v-icon :color="estiloTarjetaTituloColor">mdi-email</v-icon>
                  </a>
                  <a v-if="notario.Web" title="Abrir página web del notario" :href="notario.Web">
                    <v-icon :color="estiloTarjetaTituloColor">mdi-web</v-icon>
                  </a>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-container>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useStore } from '../../store'
import { useUtils } from '#imports'
import { useStyles } from '../../store/styles'

const { imagenIDtoSRC, $t } = useUtils()
const store = useStore()
const { NOTARIA } = storeToRefs(store)
const style = useStyles()

const viewportWidth = ref(0)

const updateViewport = () => {
  viewportWidth.value = window.innerWidth
}

onMounted(() => {
  updateViewport()
  window.addEventListener('resize', updateViewport)
})

onUnmounted(() => {
  window.removeEventListener('resize', updateViewport)
})

const imageMaxHeight = computed(() => {
  if (viewportWidth.value >= 1400) return '420px'
  if (viewportWidth.value >= 1024) return '360px'
  if (viewportWidth.value >= 768) return '300px'
  return '240px'
})

const comNumColumnas = computed(() => {
  const cols = Number(NOTARIA.value.Theme.Notarios.NumeroColumnas || 1)
  if (cols == 1) return 12
  if (cols == 2) return 6
  if (cols == 3) return 4
  if (cols == 4) return 3
  return 12 // fallback a 1 columna
})

const estiloTarjetaTituloColor = style.ThemeSectionNotario.Tarjeta.Titulo.css.Color || ''

const tituloStyle = computed(() => ({
  color: estiloTarjetaTituloColor,
  textShadow: style.ThemeSectionNotario.Tarjeta.Titulo.css.BackgroundColor ? `4px 2px 6px ${style.ThemeSectionNotario.Tarjeta.Titulo.css.BackgroundColor}` : '',
  fontFamily: style.ThemeSectionNotario.Tarjeta.Titulo.css.Font || '',
  fontSize: style.ThemeSectionNotario.Tarjeta.Titulo.css.Size || '',
  fontWeight: style.ThemeSectionNotario.Tarjeta.Titulo.css.Weight || '',
  textAlign: style.ThemeSectionNotario.Tarjeta.Titulo.css.Align || ''
}))

const descripcionStyle = computed(() => ({
  color: style.ThemeSectionNotario.Tarjeta.Descripcion.css.Color || '',
  textShadow: style.ThemeSectionNotario.Tarjeta.Descripcion.css.BackgroundColor ? `4px 2px 6px ${style.ThemeSectionNotario.Tarjeta.Descripcion.css.BackgroundColor}` : '',
  fontFamily: style.ThemeSectionNotario.Tarjeta.Descripcion.css.Font || '',
  fontSize: style.ThemeSectionNotario.Tarjeta.Descripcion.css.Size || '',
  fontWeight: style.ThemeSectionNotario.Tarjeta.Descripcion.css.Weight || '',
  textAlign: style.ThemeSectionNotario.Tarjeta.Descripcion.css.Align || ''
}))
</script>

<style scoped lang="scss">
.notario-horizontal-card {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
  width: 100%;
  padding: 20px;
  
  &:hover {
    box-shadow: 0 10px 30px rgba(0,0,0,0.08);
  }
}

.notario-image-wrapper {
  width: 100%;
  margin-bottom: 2rem;
}

.notario-content-wrapper {
  width: 100%;
}

@media (min-width: 960px) {
  .notario-horizontal-card {
    padding: 40px;
  }
  
  .notario-image-wrapper {
    width: 40%;
    margin-bottom: 0;
  }
  
  .notario-horizontal-card.flex-md-row .notario-image-wrapper {
    padding-right: 48px;
    padding-left: 0;
  }

  .notario-horizontal-card.flex-md-row-reverse .notario-image-wrapper {
    padding-left: 48px;
    padding-right: 0;
  }
  
  .notario-content-wrapper {
    width: 60%;
  }
}

.horizontal-thumb {
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
}

.hover-zoom {
  transition: transform 0.5s ease;
  &:hover {
    transform: scale(1.05);
  }
}

.thumbnail {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.thumbnail img {
  max-width: 100%;
  max-height: 100%;
  object-fit: cover;
}

.notarios-card {
  padding: 20px;
}

.link-item {
  margin-right: 2rem;
  display: inline-flex;
  align-items: center;
  text-decoration: none;
  transition: opacity 0.2s;
  
  &:hover {
    opacity: 0.7;
  }
  
  span {
    font-size: 0.9rem;
    font-weight: 500;
  }
}

.notarios-card-vertical {
  background: #fff;
  padding: 24px;
  border-radius: 12px;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 30px rgba(0,0,0,0.08);
  }
}
</style>
